module.exports = __webpack_public_path__ + "static/media/house-signal.d4400b97.svg";